<template>
  <div class="p-3">
    <div class="row no-gutters">
      <form v-on:submit.prevent>
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <validated-input v-model="item.name" label="Name" :name="`name`" validate="required|max:200" />
          </div>
          <div class="col-md-4 col-sm-6">
            <validated-input v-model="item.carrier" label="Carrier" :name="`carier`" validate="max:200" />
          </div>
          <div class="col-md-4 col-sm-6">
            <validated-input v-model="item.code" label="Code" :name="`code`" validate="max:200" />
          </div>
        </div>
      </form>
    </div>

    <div class="d-flex justify-content-between border-top pt-3">
      <div class="flex-grow">
        <span class="col-md-12 text-danger" v-if="error">{{ error.message }}</span>
      </div>
      <div class="d-flex justify-content-end">
        <b-btn @click="cancel" variant="primary" class="btn btn-light mr-2"> Close </b-btn>
        <b-btn @click="submit" variant="primary" :disabled="errors.any() || pending">
          <i class="far fa-spinner-third fa-spin text-white" v-show="pending"></i>
          Save
        </b-btn>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['$validator'],
  props: {
    options: Object,
    error: Object | Boolean,
    item: Object,
    pending: Boolean
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      await this.$validator.validateAll();
      if (this.errors.any()) {
        console.log('err', this.errors.any());
        return;
      }
      this.$emit('submit', this.item);
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
